"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _constants = require("../constants");

function useInitials(_ref) {
  var name = _ref.name,
      entityType = _ref.entityType;
  return (0, _react.useMemo)(function () {
    if (!name) {
      return '';
    }

    var parts = name.trim().split(/\s+/).map(function (w) {
      return w.replace(/[^\w\s]/gi, '');
    }).filter(Boolean);
    var words = entityType === _constants.entityTypes.person ? [parts.shift(), parts.pop()] : [parts[0], parts[1]];
    return words.filter(Boolean).map(function (n) {
      return n && n[0];
    }).join('');
  }, [name, entityType]);
}

var _default = useInitials;
exports.default = _default;